// Admin scopes for machine admin access (ADR-0028). The server checks every rule; the console explains them.
import type { AdminScope, Principal } from "../api/types";

export const ADMIN_SCOPES: { scope: AdminScope; text: string }[] = [
  { scope: "admin:read", text: "Read everything in this tenant, including the audit log." },
  { scope: "namespaces:write", text: "Create namespaces. Delete stays owner-only." },
  { scope: "trust_configs:write", text: "Create, delete and test trust configs." },
  { scope: "principals:write", text: "Create, change, revoke and delete principals." },
  { scope: "grants:write", text: "Create and delete grants." },
];

/** Scopes a principal kind may hold: an API key principal only admin:read. */
export function allowedScopes(p: Pick<Principal, "kind">): AdminScope[] {
  return p.kind === "api_key" ? ["admin:read"] : ADMIN_SCOPES.map((s) => s.scope);
}

/** True if any scope in the list can write. */
export function hasWriteScope(scopes: AdminScope[]): boolean {
  return scopes.some((s) => s !== "admin:read");
}

/** Scopes in the fixed display order, without duplicates. */
export function sortScopes(scopes: AdminScope[]): AdminScope[] {
  return ADMIN_SCOPES.map((s) => s.scope).filter((s) => scopes.includes(s));
}
